import http from "../../../libs/http"
import { StoreLocation } from "../../../types/common";
import { Product } from "../../../types/product";
const homeService = {
    fetchPopularNow: async (city: string) => {
       const { data } = await http.get('/api/products/popular', {
        params: {
            city
        }
       });

       return data as Product[];
    },

    fetchNewProducts: async (city: string) => {
       const { data } = await http.get('/api/products/news', {
        params: {
            city
        }
       });

       return data as Product[];
    },

    fetchStoreLocation: async () => {
        const { data } = await http.get('/api/misc/store-locations');

        return data as StoreLocation[];
    }
}

export default homeService;